// Module
var code = `<div *ngIf="paymentSchedules && paymentSchedules.length > 0"><br><br></div>
<div class="HOA-propertyblock-flextable" *ngIf="paymentSchedules && paymentSchedules.length > 0">
	<div class="HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--30 HOA-propertyblock-flextable__cell--30-ifSizeIsLargerThanPhone HOA-propertyblock-flextable--truncate">
		<div class="HOA-propertyblock-flextable__cell-label HOA-propertyblock-flextable--truncate"
			 tid="column2Header">Schedule Name
		</div>
	</div>
	<div class="HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--20  HOA-propertyblock-flextable__cell--20-ifSizeIsLargerThanPhone HOA-propertyblock-flextable--truncate">
		<div class="HOA-propertyblock-flextable__cell-label HOA-propertyblock-flextable--truncate u-margin-right-align-if-size-phone"
			 tid="column3Header">Next Payment
		</div>
	</div>
    <div class="HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--10 HOA-propertyblock-flextable__cell--10-ifSizeIsLargerThanPhone HOA-propertyblock-flextable--truncate">
        <div
            class="HOA-propertyblock-flextable__cell-label HOA-propertyblock-flextable--truncate"
            tid="column1Header"></div>
    </div>
	<div class="HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--15  HOA-propertyblock-flextable__cell--20-ifSizeIsLargerThanPhone HOA-propertyblock-flextable--truncate">
		<div class="HOA-propertyblock-flextable__cell-label HOA-propertyblock-flextable--truncate u-margin-right-align-if-size-phone"
			 tid="column4Header">Type
		</div>
	</div>
	<div class="HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--20 HOA-propertyblock-flextable__cell--20-ifSizeIsLargerThanPhone HOA-propertyblock-flextable--truncate">
		<div class="HOA-propertyblock-flextable__cell-label u-margin-right-align HOA-propertyblock-flextable--truncate"
			 tid="column5Header">Amount
		</div>
	</div>
	<ng-container *ngFor="let paymentSchedule of paymentSchedules; index as \$index">
		<div class="HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--30 HOA-propertyblock-flextable__cell--30-ifSizeIsLargerThanPhone HOA-propertyblock-flextable--truncate">
			<div class="HOA-propertyblock-flextable__cell-value HOA-propertyblock-flextable--truncate HOA-propertyblock-flextable--truncate-addMarginOnFocus"
				 tid="scheduleNickname">
                {{paymentSchedule.nickname}}
			</div>
		</div>
		<div class="HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--20 HOA-propertyblock-flextable__cell--20-ifSizeIsLargerThanPhone HOA-propertyblock-flextable--truncate">
			<div class="HOA-propertyblock-flextable__cell-value HOA-propertyblock-flextable--truncate u-margin-right-align-if-size-phone" tid="paymentDate">
				{{paymentSchedule.nextPaymentDate.formattedFullDate}}
			</div>
		</div>
        <div class="HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--10 HOA-propertyblock-flextable__cell--10-ifSizeIsLargerThanPhone">
            <div class="HOA-propertyblock-flextable__cell-value HOA-propertyblock-flextable--truncate HOA-propertyblock-flextable--truncate-addMarginOnFocus green" tid="edit">
                <a (click)="navigateToScheduleEditPayment(paymentSchedule.id, paymentSchedule.frequency)"
                   [attr.tid]="'scheduleEdit-' + \$index">Edit
                </a>
            </div>
        </div>
		<div class="HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--15 HOA-propertyblock-flextable__cell--20-ifSizeIsLargerThanPhone HOA-propertyblock-flextable--truncate capitalize">
			<div class="HOA-propertyblock-flextable__cell-value HOA-propertyblock-flextable--truncate u-margin-right-align-if-size-phone" tid="paymentType">
                {{ paymentSchedule.frequency === 'one-time' ? 'One-Time Payment' : (paymentSchedule.type | formatStatus) }}
			</div>
		</div>
		<div class="HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--20 HOA-propertyblock-flextable__cell--20-ifSizeIsLargerThanPhone HOA-propertyblock-flextable--truncate ">
			<div class="HOA-propertyblock-flextable__cell-value u-margin-right-align u-textRight HOA-propertyblock-flextable--wrap" tid="nextPaymentAmount">
				{{paymentSchedule.nextPaymentAmount ? (paymentSchedule.nextPaymentAmount | currency:"\$") : "Next Assessment Amount" }}
			</div>
		</div>
	</ng-container>
</div>
<div class="HOA-flextable-component HOA-flextable-component__cell-100" *ngIf="!paymentSchedules || paymentSchedules.length <= 0">
	<div class="HOA-flextable-component__cell-value HOA-payment-schedule__cell" tid="noScheduleText">
                <span *ngIf="isPaymentMethodView === true">
                    There is not a scheduled payment set up for this payment method.
                </span>
		<span *ngIf="isPaymentMethodView !== true">
                    You have no scheduled payments.
                </span>
	</div>
</div>`;
// Exports
module.exports = code;